export default class OrderResponse {
    pedido          = "";
    valorTotal      = 0;
    qtnParcela      = "";
    id              = "";
    formaPagamento  = "Cartão de crédito";
    itemPedido      = "Crédito para Bilhete Urbs";
    mensagem        = "Para recarregar os créditos, basta validar seu cartão em qualquer posto autorizado.";

    

    constructor(pedido, valorTotal, qtnParcela, id){
        this.pedido = pedido;
        this.valorTotal = valorTotal;
        this.qtnParcela = qtnParcela;
        this.id = id;
    }
    

    getIdPedido() { return this.pedido; }

    getValorTotal() { return this.valorTotal; }

    getQtnParcela() { return this.qtnParcela; }
}